module.exports = __webpack_public_path__ + "static/img/10.fcf728a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/10.png
// module id = 1Iib
// module chunks = 0